module.exports = __webpack_public_path__ + "img/about-3.35a2d969.jpg";